import {CreateLiveEventMultiStepForm} from "../multi-step-form";

export function CreateLiveEventMultiStepFormWrapper() {
  return <CreateLiveEventMultiStepForm />;
}
